import { FormlyMaterialModule } from '@ngx-formly/material';
import { FormlyMatToggleModule } from '@ngx-formly/material/toggle';
import { NgModule } from '@angular/core';
import { MatFormFieldDefaultOptions, MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { FormlyBaseModule } from './formly-base.module';
import { MaterialDesignModule } from './material-design.module';

// FormlyMaterialModule
export const matFormFieldDefaultOptions: MatFormFieldDefaultOptions = {
  // appearance: 'standard',
  appearance: 'fill',
  floatLabel: 'always'
};

const MODULES = [
  // FormlyBaseModule,
  FormlyMatToggleModule,
  FormlyMaterialModule
];

@NgModule({
  imports: [
    ...MODULES,
    MaterialDesignModule
  ],
  exports: [
    ...MODULES,
  ],
  providers: [
    { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: matFormFieldDefaultOptions }
  ]
})
export class CustomFormlyMaterialModule {
}
